import React, { useCallback } from 'react';
import { useFormikContext } from 'formik';

import { ErrorField } from '@/components/error-field';
import { RequiredLabel } from '@/components/required-label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Field } from '@/components/ui/field';
import { VariableTextarea } from '@/components/ui/variable-textarea';

import { useFormikError } from '@/lib/error';
import { extractPromptVariables } from '@/lib/prompt';

export const SystemPrompt = React.memo(() => {
  const { setFieldValue, getFieldProps } = useFormikContext();
  const hasError = useFormikError();

  const onChange = useCallback((value: string) => {
    setFieldValue('system_prompt', value);
    setFieldValue('prompt_variables', extractPromptVariables(value));
  }, []);

  return (
    <Card className="bg-muted rounded-2xl gap-0 p-1 border-0">
      <CardHeader className="px-5 py-3">
        <div>
          <CardTitle className="text-sm font-medium mb-1">
            <RequiredLabel>Agent prompt</RequiredLabel>
          </CardTitle>
          <p className="text-sm text-muted-foreground">
            The system prompt is used to determine the persona of the agent and the context of the
            conversation. Learn more
          </p>
        </div>
      </CardHeader>
      <CardContent className="bg-card rounded-xl shadow-sm p-5 space-y-4">
        <Field aria-invalid={hasError('system_prompt')}>
          <VariableTextarea
            className="min-h-96 max-h-[500px] overflow-y-auto"
            aria-invalid={hasError('system_prompt')}
            {...getFieldProps('system_prompt')}
            onValueChange={onChange}
          />
          <p className="text-xs text-muted-foreground">
            Type{' '}
            <span className="font-medium py-px px-1 border rounded-lg text-foreground bg-gray-50 dark:bg-gray-900 border-gray-200 dark:border-gray-800">
              {'{{'}
            </span>{' '}
            to add variables
          </p>
          <ErrorField name="system_prompt" />
        </Field>
      </CardContent>
    </Card>
  );
});
